import { call, put, takeEvery } from 'redux-saga/effects'
import { generalDoFailure } from '../../../util/fetchFailure'
import { privateFetch } from '../../../fetch'
import {
  API_URL_PATH_KEG_COLLECTION_BOOKINGS,
  API_URL_PATH_KEG_COLLECTIONS,
} from '../../../../../constants'

import {
  saveEditedKegCollectionBooking,
  editKegCollectionBookingRequest,
  editKegCollectionBookingSuccess,
  editKegCollectionBookingFailure,
} from './utils'

import { UPDATE_KEG_COLLECTION_BOOKING } from '../../../../actions/actionTypes'

function* editBookingWorker(action) {
  if (!action) return
  const { bookingId, updatedBookingParams, kegCollectionObjToUpdate } = action.payload || {}

  yield put(editKegCollectionBookingRequest())

  let response
  try {
    let preflight
    if (kegCollectionObjToUpdate) {
      preflight = yield call(privateFetch, {
        path: `${API_URL_PATH_KEG_COLLECTIONS}/${kegCollectionObjToUpdate.id}`,
        method: 'PUT',
        data: kegCollectionObjToUpdate,
      })
    }

    const etag = preflight?.headers?.etag
    const headers = etag ? { 'If-Match': etag } : {}

    response = yield call(privateFetch, {
      path: `${API_URL_PATH_KEG_COLLECTION_BOOKINGS}/${bookingId}`,
      method: 'PUT',
      data: updatedBookingParams,
      headers,
    })
    const bookingDetails = response.data
    yield call(doSuccess, { bookingDetails })
  } catch (error) {
    yield call(doFailure, {
      error,
    })
  }
}

export default [[takeEvery, UPDATE_KEG_COLLECTION_BOOKING, editBookingWorker]]

function* doSuccess({ bookingDetails }) {
  yield put(saveEditedKegCollectionBooking(bookingDetails))
  yield put(editKegCollectionBookingSuccess())
}

function* doFailure({ error }) {
  yield call(generalDoFailure, {
    error,
    action: editKegCollectionBookingFailure(error),
  })
}
